export default __webpack_public_path__ + "static/media/lightInformation.36c80d18.svg";